import { Button, Form, Input } from 'antd';
import { observer } from 'mobx-react';
import React, { useState } from 'react';
import { MerchantBreadcrumb } from '../../../config/BreadcrumbConfig';
import PageHeader from '../../../component/PageHeader';
import useStore from '../../../store';
import ListComponent from './components/ListComponent';
import AddComponent from './components/AddComponent';
import EditComponent from './components/EditComponent';
import DeleteComponent from './components/DeleteComponent';

const Merchant = observer(() => {
	const [merchantAddModal, setMerchantAddModal] = useState(false);
	const [merchantEditModal, setMerchantEditModal] = useState(false);
	const [merchantDeleteModal, setmerchantDeleteModal] = useState(false);
	const { MERCHANT } = useStore();

	const AddMerchantModal = () => {
		setMerchantAddModal(true);
	};

	const closeAddModal = () => {
		setMerchantAddModal(false);
	};

	const openEdit = () => {
		setMerchantEditModal(true);
	};

	const closeEditModal = () => {
		setMerchantEditModal(false);
	};

	const openDelete = (data) => {
		setmerchantDeleteModal(data);
	};

	const closeDeleteModal = () => {
		setmerchantDeleteModal(false);
	};

	const onSearch = (text) => {
		if (text.length >= 3 || text.length === 0) {
			MERCHANT.searchValue = text;
			MERCHANT.setupGrid(MERCHANT.agGrid);
		}
	};

	return (
		<div className="mainPageWrap">
			<PageHeader
				className="mainPageHeader"
				title={MerchantBreadcrumb.title}
				extra={[
					<Form.Item help={'Write 3 letters to search'} key={1}>
						<Input
							placeholder="Search here"
							onChange={(e) => onSearch(e.target.value)}
						/>
					</Form.Item>,
					<Button
						key={2}
						type="primary"
						className="addBtn"
						onClick={AddMerchantModal}
					>
						Add Merchant
					</Button>,
				]}
			/>
			<ListComponent
				openEditModal={openEdit}
				openDeleteModal={openDelete}
			/>
			<AddComponent visible={merchantAddModal} onClose={closeAddModal} />
			<EditComponent
				visible={merchantEditModal}
				onClose={closeEditModal}
			/>
			<DeleteComponent
				visible={merchantDeleteModal}
				onClose={closeDeleteModal}
			/>
		</div>
	);
});

export default Merchant;
